import type React from 'react';

import { ProgressStepper, Text } from '@change/ds-core-ui';

import { PromoteFormBodyContainer } from '../PromoteForm';

import { ComboStory } from './components/ComboStory';
import { HeroFeed } from './components/HeroFeed';
import { ImpactBox } from './components/ImpactBox';
import { PetitionMedia } from './components/PetitionMedia';
import { PromoteOrShareActions } from './components/PromoteOrShareActions';
import { usePageBody } from './hooks/usePageBody';

export const PageBody: React.FC = () => {
	const {
		data: { heading, subHeading1, showSubHeading1, heroFeed, pageTitle, showImpactBox },
	} = usePageBody();

	return (
		<div className="mx-auto max-w-[610px]">
			<PetitionMedia />
			<div className="bg-background-base elevation-elevated relative rounded-2xl py-7 md:py-9">
				<div className="flex flex-col gap-7 px-6 md:gap-9 md:px-10">
					<div className="flex flex-col justify-center gap-3 pb-3">
						{pageTitle && <Text className="text-center">{pageTitle}</Text>}
						<ProgressStepper currentStepNumber={2} numberOfSteps={3} />
					</div>
					<div className="flex flex-col" data-qa="description">
						<Text variant="heading" as="h1" className="m-0 mb-3 md:mb-4">
							{heading}
						</Text>
						{showSubHeading1 && <Text className="text-typography-weak mb-7 md:mb-9 md:text-lg">{subHeading1}</Text>}

						<ComboStory />

						{showImpactBox && (
							<ImpactBox className="mt-4">
								{heroFeed.items.length > 0 && <HeroFeed items={heroFeed.items} data-qa="hero-feed-mobile-impact" />}
							</ImpactBox>
						)}
					</div>

					<PromoteOrShareActions />
					<PromoteFormBodyContainer />
				</div>
			</div>
		</div>
	);
};
